import React from 'react'
import { Row, Col, Alert, Button } from 'react-bootstrap'
import TextField from './text-field'
import { get } from 'lodash'
import RolesSelector from './roles-selector'
import USER_ROLES from '../../../constants/user-roles'
import useApiMutation from '../../../hooks/use-api-mutation'
import useToasts from '../../../hooks/use-toasts'
import userService from '../../../services/api/user'
import useUserValidation from '../../../hooks/use-user-validation'
import SpinnerButton from '../../common/spinner-button'

const NewUserForm = ({
    onComplete = () => {}
}) => {

    const { success: onSuccess, error: onError } = useToasts({
        successMessage: 'User created!',
        errorMessage: 'Error creating user.',
        onSuccess: onComplete
    })

    const {
        data: user,
        setData: onChange,
        isBusy,
        save,
    } = useApiMutation({
        onSuccess,
        onError,
        onCreate: (user) => userService.create(user),
        defaultData: { rolesCode: 's' }
    })

    const { validateUser, error } = useUserValidation({
        onValid: save,
        user
    })

    const rolesCode = get(user, 'rolesCode', '')
    const isStudent = rolesCode.includes(USER_ROLES.STUDENT)

    const renderError = () => {
        if (!error) {
            return null
        }

        return (<Alert variant='danger'>{error}</Alert>)
    }

    return (
        <div style={{ paddingTop: '20px'}}>
            <div>
                <Row>
                    <Col lg={12} xl={6}>
                        <RolesSelector
                            value={user}
                            onChange={onChange}
                        />
                    </Col>
                    <Col lg={12} xl={6}>
                        <TextField
                            required
                            label='Full First Name'
                            value={user}
                            onChange={onChange}
                            keyField='firstName'
                        />
                        <TextField
                            required
                            label='Legal Last Name'
                            value={user}
                            onChange={onChange}
                            keyField='lastName'
                        />
                        <TextField
                            required
                            label='DSHA Email Address'
                            value={user}
                            onChange={onChange}
                            keyField='email'
                        />
                        {isStudent &&
                            <TextField
                                required
                                label='Student ID'
                                value={user}
                                onChange={onChange}
                                keyField='studentId'
                            />
                        }
                        {isStudent &&
                            <TextField
                                required
                                type='number'
                                label='Graduation Year'
                                placeholder='ex: 2022'
                                value={user}
                                onChange={onChange}
                                keyField='gradYear'
                            />
                        }
                    </Col>
                </Row>
            </div>
            <div>{renderError()}</div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '20px'}}>
                <Button variant="link" onClick={() => onComplete()}>Discard</Button>
                <SpinnerButton busy={isBusy} disabled={isBusy} onClick={() => validateUser()}>{isBusy ? 'Adding...' : 'Add New User'}</SpinnerButton>
            </div>
        </div>
    )
}

export default NewUserForm